import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { ModalWindowSizeEnum } from '../types'

export interface ModalWindowBodyProps {
  children: ReactNode
  size?: ModalWindowSizeEnum
  className?: string
}

export const ModalWindowBody = ({
  children,
  size = ModalWindowSizeEnum.Medium,
  className,
}: ModalWindowBodyProps) => {
  return (
    <div
      className={twMerge(
        'w-full p-0',
        size === ModalWindowSizeEnum.Small && 'px-6 py-4',
        size === ModalWindowSizeEnum.Medium && 'px-8 py-6',
        className,
      )}
    >
      {children}
    </div>
  )
}
